import { render, staticRenderFns } from "./BikeInfoSysItem.vue?vue&type=template&id=270669ca&"
import script from "./BikeInfoSysItem.vue?vue&type=script&lang=js&"
export * from "./BikeInfoSysItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports